
import VueSelect from "vue-select";

export default {
  name: "app-cadastro-rapido-select",
  inheritAttrs: false,
  components: {
    VueSelect,
  },
  props: {
    value: {
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "nome",
    },
    entityLabel: {
      type: String,
      required: true,
    },
    creating: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minCreateLength: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      searchTerm: "",
      searching: false,
    };
  },
  computed: {
    opcoesComCadastroRapido() {
      const opcoes = Array.isArray(this.options) ? this.options : [];
      const nome = this.searchTerm.trim();

      if (
        nome.length < this.minCreateLength ||
        this.searching ||
        this.creating
      ) {
        return opcoes;
      }

      const nomeNormalizado = this.normalizar(nome);
      const opcaoExistente = opcoes.some(
        (opcao) => this.normalizar(opcao?.[this.label]) === nomeNormalizado
      );

      if (opcaoExistente) {
        return opcoes;
      }

      return [
        ...opcoes,
        {
          __cadastroRapido: true,
          [this.label]: nome,
        },
      ];
    },
  },
  methods: {
    normalizar(value) {
      return String(value || "")
        .trim()
        .toLocaleLowerCase("pt-BR");
    },
    onInput(option) {
      if (option?.__cadastroRapido) {
        this.$emit("create", option[this.label]);
        return;
      }

      this.searchTerm = "";
      this.$emit("input", option);
    },
    onOpen() {
      this.$emit("open", "", (value) => {
        this.searching = Boolean(value);
      });
    },
    onSearch(search, toggleLoading) {
      this.searchTerm = search || "";
      this.searching = false;

      this.$emit("search", search, (value) => {
        this.searching = Boolean(value);
        toggleLoading(value);
      });
    },
  },
};
